import { type ReactNode } from 'react';
import { Avatar } from '@/components/ui/avatar';
import { HealedHeartMark } from '@/components/ui/healed-heart-mark';
import { pbFileUrl } from '@/utils/pb-file-url';
import { displayName } from '@/utils/formatters';
import { useTeamMember } from '../hooks/use-team-member';

function memberPhotoUrl(m: {
  id: string;
  collectionId: string;
  photo: string;
}): string {
  return m.photo ? pbFileUrl(m, m.photo) : '';
}

export function CollectorHeader({
  collectorId,
}: {
  collectorId: string;
}): ReactNode {
  const { data } = useTeamMember(collectorId);
  if (!data) return null;

  const redeemed = !!data.has_used_redemption && !!data.redemption_passed_at;
  return (
    <div className="flex items-center gap-sm">
      <Avatar src={memberPhotoUrl(data)} name={data.ig_username} size="lg" />
      <div>
        <p className="flex items-baseline gap-1 text-sm font-semibold text-text-primary">
          {displayName(data)}
          {redeemed && <HealedHeartMark />}
        </p>
        {data.first_name && (
          <p className="text-[11px] text-text-tertiary">@{data.ig_username}</p>
        )}
      </div>
    </div>
  );
}
